import _, { isString } from 'lodash';

export const getResizedText = (originalText: string, characterLimit: number) => {
  if (originalText && isString(originalText) && originalText.length > characterLimit) {
    return originalText.slice(0, characterLimit) + '...';
  }
  return originalText;
};

export const scrollbarStyle = {
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.3em',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#888',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
};
